import {SimplePresentation} from "./SimplePresentationRunner";
import {Possessed} from "../../Possessed";
import {SimpleReelModelState} from "../../../core/reel/simplereel/SimpleReelModel";
import {gsap} from "gsap";
import {PossessedSymbolFactory} from "../../reels/PossessedSymbolFactory";
import {PossessedWildSymbol} from "../../reels/PossessedWildSymbol";
import {PossessedStatics} from "../../config/PossessedStatics";

export class ExpandWildPresentation extends SimplePresentation {

    constructor() {
        super("ExpandWild Presentation");
    }

    shouldRun() {
        const ws = Possessed.model.getWildSymbol();
        return (ws != undefined && ws.shouldExpand);
    }

    buildTimeline() {
        const tl = this.tl;

        const wildData = Possessed.model.getWildSymbol()!;
        const wildSymbol = <PossessedWildSymbol>Possessed.reelView.getVisibleSymbolAt(wildData.reelID, wildData.reelPosition);
        const wildRow = wildData.reelPosition;
        const startPosY = wildSymbol.position.y;

        const turnToWild = (reelID:number, reelPos:number, hideNewWild:boolean = false) => {
            const replaceOffset = Math.min(Math.abs(reelPos - wildRow), 1) * 90;
            const tl = gsap.timeline()
                .add(() => {
                    // Hide mystery reel at position
                    const mysteryReel = activeMysteryReels.find(reel => reel.reelID == reelID && reel.reelPosition == reelPos);
                    if(mysteryReel) {
                        mysteryReel.visible = false;
                    }
                })
                .add(() => {
                    const newWild = <PossessedWildSymbol>PossessedSymbolFactory.createSymbol("W", reelID, reelPos);
                    Possessed.reelView.replaceSymbolAt(reelID, reelPos, newWild);
                    //Possessed.reelView.replaceSymbolAt(reelID, reelPos, Possessed.reelView.createSymbol("W",
                    //    SimpleReelModelState.IDLE,
                    //    reelID,
                    //    reelPos))
                    Possessed.reelView.wildSymbolsView.addSymbol(newWild);
                    newWild.isExpandedWild = true;
                    if(hideNewWild) {
                        newWild.visible = false;
                    }
                })
            return tl;
        };

        if(wildRow != 3) {
            // Nudge down wild symbol
            const nudges = 4 - wildRow;
            const startPos = wildSymbol.position.y;
            //for(let i = 0; i < nudges; i++) {
            //    tl.add(wildSymbol.nudgeDown(), ">");
            //    tl.add(gsap.to(wildSymbol.position, {
            //        y: startPos + (PossessedStatics.SYMBOL_HEIGHT * (i+1)),
            //        duration: 0.4 - (i*0.12),
            //        ease: "power4.out"
            //    }), "<");
            //    //tl.add(turnToWild(wildSymbol.reelID, wildSymbol.reelPosition + i + 1, true));
            //}
            tl.add(gsap.to(wildSymbol.position, {
                y: startPos + (PossessedStatics.SYMBOL_HEIGHT * nudges),
                duration: 0.3,
                ease: "bounce.out"
                //ease: "power4.out"
            }));
            tl.add(() => {
                Possessed.soundPlayer.playSound("wildNudgeLand");
            }, ">-0.07");

            // Turn middle reel cross symbols into wild
            [1, 2, 3, 4].forEach(row => {
                tl.add(turnToWild(2, row, true));
            });

        } else {
            if (wildData.shouldExpand) {
                tl.add(() => {});

                [1, 2, 3, 4].filter((row) => row != wildRow).forEach((row) => {
                    tl.add(turnToWild(2, row, true), "<")
                })

                tl.add(turnToWild(1, 3, true), "<");
                tl.add(turnToWild(3, 3, true), "<");
            }
        }

        const expandTL = gsap.timeline();
        tl.add(()=> {
            let centerWild = <PossessedWildSymbol>Possessed.reelView.getSymbolAt(2,3);
            centerWild.visible = true;
            if(wildRow != 3) {
                expandTL.add(centerWild.expandUp());
            } else {
                expandTL.add(centerWild.expandFullCross());
            }
            const wildMultiplier = (4 - wildRow) + 1;

            expandTL.add(Possessed.backgroundElements.playShake(wildMultiplier > 1 ? 2 : 1), "<");

            expandTL.add(Possessed.reelView.reelCross.triggerWildGirl(wildMultiplier), "<");
        })
        tl.add(expandTL);
        tl.add(Possessed.reelView.fadeOutWildExpandAnticipationEffects(0.2), "<");

        const activeMysteryReels = Possessed.reelView.reelCross.getActiveMysteryReels().filter(reel => reel.visible);

        tl.add(()=> {}, ">0.2");
    }
}